import z, { ZodPipe, ZodString, ZodTransform } from 'zod';
import { refineDateString } from './helpers';

type GetDateFieldFormSchemaParamsType = {
  invalidFormatMessage: string;
  invalidDateMessage: string;
};

type GetDateFieldFormSchemaReturnType = ZodPipe<
  ZodString,
  ZodTransform<string, string>
>;

export const getDateFieldFormSchema = ({
  invalidFormatMessage,
  invalidDateMessage,
}: GetDateFieldFormSchemaParamsType): GetDateFieldFormSchemaReturnType => {
  return z
    .string()
    .regex(/^\d{2}\.\d{2}\.\d{4}$/, {
      message: invalidFormatMessage,
    })
    .refine(refineDateString, { message: invalidDateMessage })
    .transform((dateString) => {
      const [day, month, year] = dateString.split('.');
      return `${year}-${month}-${day}`;
    });
};
